import Vue from "vue";
import {
  Button,
  Menu,
  MenuItem,
  Row,
  Col,
  submenu,
  MenuItemGroup,
  Select,
  Option,
  Input,
  DatePicker,
  Table,
  TableColumn,
  Pagination,
  Form,
  FormItem,
  Switch,
  Dialog,
  CheckboxGroup,
  Checkbox,
  Tree,
  Radio,
} from "element-ui";

[
  Button,
  Menu,
  MenuItem,
  Row,
  Col,
  submenu,
  MenuItemGroup,
  Select,
  Option,
  Input,
  DatePicker,
  Table,
  TableColumn,
  Pagination,
  Form,
  FormItem,
  Switch,
  Dialog,
  CheckboxGroup,
  Checkbox,
  Tree,
  Radio,
].forEach((el) => {
  Vue.use(el);
});
